"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateStylableBreakpoints = exports.generateStylableTheme = exports.generateStylableThemeVars = void 0;
var consts_1 = require("../consts");
var font_utils_1 = require("../fonts/font-utils");
var generateSiteColorVarKey = function (x, y) { return "site_" + x + "_" + y; };
var varsBlock = function (declarations) {
    return ":vars {\n" + Object.keys(declarations)
        .map(function (name) { return "    " + name + ": " + declarations[name] + ";"; })
        .join('\n') + "\n}";
};
var classRule = function (className, declarations) {
    return "." + className + " { " + Object.keys(declarations)
        .map(function (name) { return name + ": " + declarations[name] + ";"; })
        .join(' ') + " }";
};
var COLOR_OFFSET = 11;
var MATRIX_DIMENSION = 5;
function generateStylableThemeVars(themeData) {
    var xFromIndex = function (index) { return Math.floor(index / MATRIX_DIMENSION) + 1; };
    var yFromIndex = function (index) { return Math.floor(index % MATRIX_DIMENSION) + 1; };
    return varsBlock(themeData[consts_1.THEME_COLOR_KEY] !== undefined ?
        themeData[consts_1.THEME_COLOR_KEY].slice(COLOR_OFFSET).reduce(function (siteColorVars, color, index) {
            siteColorVars[generateSiteColorVarKey(xFromIndex(index), yFromIndex(index))] = color;
            return siteColorVars;
        }, {})
        : {});
}
exports.generateStylableThemeVars = generateStylableThemeVars;
function generateStylableTheme(themeData, fontThemes) {
    var siteColorsVarsString = generateStylableThemeVars(themeData);
    var fontThemeClasses = fontThemes || font_utils_1.getFontThemeClasses(themeData);
    var fontThemeClassesString = Object.keys(fontThemeClasses)
        .map(function (fontStyleName) { return classRule(fontStyleName, fontThemeClasses[fontStyleName]); })
        .join('\n');
    return siteColorsVarsString + '\n' + fontThemeClassesString;
}
exports.generateStylableTheme = generateStylableTheme;
function generateStylableBreakpoints(isMobile) {
    var _a;
    return varsBlock((_a = {},
        _a[consts_1.mobileMediaQueryVarName] = isMobile ? consts_1.mobileMediaQueryOn : consts_1.mobileMediaQueryOff,
        _a));
}
exports.generateStylableBreakpoints = generateStylableBreakpoints;
//# sourceMappingURL=injections.js.map